<template>
  <div class="shop-filter">
    <button v-if="compact" type="button" class="filter-open-btn" @click="toggleMenu">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M2 3.5h12M4.5 8h7M7 12.5h2" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/>
      </svg>
      <span>Filter</span>
      <span v-if="selectedCount > 0" class="filter-count-badge">{{ selectedCount }}</span>
    </button>
    <vs-button
      v-else
      @click="toggleMenu"
      :icon-after="true"
      type="border"
      class="w-full"
      style="height: 38px; border: 1px solid rgba(0, 0, 0, 0.2)"
      icon="menu"
      >Filter</vs-button
    >

    <vs-sidebar
      :click-not-close="true"
      class="md:hidden products-sidebar relative spacer"
      parent="body"
      default-index="-1"
      v-model="showSidebar"
      style="z-index: 51000"
    >
      <div class="flex items-center px-4" slot="header">
        <p
          class="font-normal text-white flex-grow text-center"
          style="font-size: 18px"
        >
          Filter {{
            jsonCategoryName && jsonCategoryName.length > 0
              ? jsonCategoryName
              : categoryDetails.name
          }}
        </p>
        <vs-icon
          class="cursor-pointer text-right"
          @click="toggleMenu"
          :style="{ height: '24px', width: '24px' }"
          size="small"
          color="white"
          icon="close"
        />
      </div>

      <div class="mx-6 text-primary2 text-lg pt-4">
        <div v-if="brands.length > 0" class="mb-8">
          <div
            class="text-2xl text-black font-semibold"
          >
            Brands
          </div>
          <div
            class="text-xl brand-filter-option"
            :key="item._id"
            v-for="(item, index) in brands"
          >
            <vs-checkbox
              class="mt-3"
              :value="item.isSelected"
              @click="onFilterClick(item, index, 'brand')"
              >{{ item.brandName }}</vs-checkbox
            >
          </div>
        </div>
        <div
          v-if="category.length > 0"
          class="text-2xl text-black font-semibold mb-4"
        >
          {{
            jsonCategoryName && jsonCategoryName.length > 0
              ? jsonCategoryName
              : categoryDetails.name
          }}
          {{ category.length === 1 ? "Category" : "Categories" }}
        </div>
        <div
          :key="item._id"
          v-for="item in category"
          class="text-xl cursor-pointer mb-3"
        >
          <a @click="categoryClick(item.slug)">{{ item.name }}</a>
        </div>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      showSidebar: false,
      windowWidth: 0,
    };
  },
  props: {
    categoryDetails: { type: Object, default: () => ({}) },
    brands: { type: Array, default: () => [] },
    category: { type: Array, default: () => [] },
    subCategories: { type: Array, default: () => [] },
    onFilterClick: { type: Function, default: null },
    onCategoryClick: { type: Function, default: null },
    jsonCategoryName: { type: String, default: '' },
    selectedCount: { type: Number, default: 0 },
    // A bare `compact` attribute is only true when the prop is a Boolean.
    compact: { type: Boolean, default: false },
  },
  methods: {
    toggleMenu() {
      this.showSidebar = !this.showSidebar;
      if (this.showSidebar) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth >= 768) {
        document.body.style.overflow = 'auto';
      }
      if (this.windowWidth <= 768 && this.showSidebar == true) {
        document.body.style.overflow = 'hidden';
      }
    },
    categoryClick(slug) {
      this.onCategoryClick(slug);
      this.toggleMenu();
    },
  },
  computed: {},
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
};
</script>

<style scope lang="scss">
.vs-sidebar {
  z-index: 50000;
}

.categories-button {
  border-radius: 5rem !important;
}

.vs-sidebar--background {
  z-index: 50000;
}

.vs-sidebar--header {
  background-color: #074230;
}

.products-sidebar.vs-content-sidebar .vs-sidebar {
  top: 0 !important;
  left: 0 !important;
  margin: 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden;
}

.products-sidebar.vs-content-sidebar .vs-sidebar--header {
  width: 100%;
  margin: 0;
}

.products-sidebar.vs-content-sidebar .vs-sidebar--items {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  max-width: 100%;
  padding: 10px 0;
}

.products-sidebar .brand-filter-option {
  min-width: 0;
  overflow: hidden;
}

.shop-filter {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: auto;
  max-width: 100%;
}

.filter-open-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: auto;
  height: 40px;
  padding: 0 12px 0 14px;
  border: 0;
  border-radius: 999px;
  background: #0e4333;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
}

.filter-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 999px;
  background: #f9f7f0;
  color: #0e4333;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
}
.category-col {
  column-count: 2;
  margin-top: 0.5rem;
}
</style>
